import React from "react";
import ExcelJS from "exceljs";

const ExcelPolicyReport = ({ data }) => {
    const exportExcelFile = async () => {
        if (!Array.isArray(data) || data.length === 0) {
            console.error("Data is not an array or empty:", data);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Policies');

        // Define columns with headers based on your data structure
        worksheet.columns = [
            { header: 'S.No', key: 'serial', width: 8 },
            { header: 'Policy ID', key: 'policy_id', width: 15 },
            { header: 'Policy Name', key: 'policy', width: 80 },
        ];

        // Apply alignment and color to header cells
        worksheet.getRow(1).eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' }, // Yellow color
            };
            cell.font = { bold: true, size: 12 };
        });

        // Flatten the data for export
        const flattenedData = data.map((item, index) => {
            return {
                serial: index + 1,
                policy_id: item.policy_id || '-',
                policy: item.policy || '-',
            };
        });

        // Add data rows with custom cell alignment
        flattenedData.forEach((item) => {
            const row = worksheet.addRow(item);

            // Apply formatting to each cell
            row.eachCell((cell, colNumber) => {
                // Default alignment for all cells
                cell.alignment = {
                    vertical: 'middle',
                    horizontal: 'left',
                    wrapText: true
                };

                // Special formatting for specific columns
                if (colNumber === 1) { // S.No column
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    cell.font = { bold: true };
                } else if (colNumber === 2) { // Policy ID column
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                }

                // Add slight indentation for policy name for better readability
                if (colNumber === 3) {
                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                }
            });
        });

        // Add borders to all cells
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        // Set row heights
        worksheet.getRow(1).height = 30; // Header row height

        // Auto-fit policy name column for better visibility
        worksheet.getColumn(3).alignment = {
            vertical: 'middle',
            horizontal: 'left',
            wrapText: true
        };

        // Auto-filter for better data management
        worksheet.autoFilter = {
            from: 'A1',
            to: 'C1'
        };

        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Generate Excel file buffer
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `Policy_Report_${formattedDate}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <button
            className="btn btn-success mt-1 mb-2"
            onClick={exportExcelFile}
            style={{ marginLeft: '10px' }}
        >
            <i className="feather icon-download"></i> Download as Excel
        </button>
    );
};

export default ExcelPolicyReport;